import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import users from '@/store/modules/users'
import detentions from '@/store/modules/detentions'
import counts from '@/store/modules/counts'
import devices from '@/store/modules/devices'
import navigation from '@/store/modules/navigation'
import flow from '@/store/modules/flow'
import loading from '@/store/modules/loading'
import VCalendar from 'v-calendar'

Vue.use(Vuex)
Vue.use(VCalendar)

const store = new Vuex.Store({
  modules: {
    users,
    detentions,
    counts,
    devices,
    navigation,
    flow,
    loading
  }
})

createPersistedState({
  key: 'vuex',
  reducer(value) {
    if(value.users.auth.token === null) {
      return {}
    }
    return value
  }
})(store)

export default store
